import { render, staticRenderFns } from "./wardContactSignUp.vue?vue&type=template&id=42645ec9&scoped=true&"
import script from "./wardContactSignUp.vue?vue&type=script&lang=js&"
export * from "./wardContactSignUp.vue?vue&type=script&lang=js&"
import style0 from "./wardContactSignUp.vue?vue&type=style&index=0&id=42645ec9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42645ec9",
  null
  
)

export default component.exports